import React, { useCallback, useMemo, useState } from 'react'
import Divider from '../../../../components/atoms/Divider'
import PageHeading from '../common/PageHeading'
import PageLayout from '../common/PageLayout'
import DebouncedInput from '../../../../components/molecules/DebouncedInput'
import Loading from '../../../../components/molecules/Loading'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import NoResults from '../common/NoResults'
import { useGetAiSkills } from '../../../../api/denaliAssistant'
import SkillCard from './SkillCard'

function SkillsHome () {
  const [searchQuery, setSearchQuery] = useState('')
  const { data: skillsData, isLoading } = useGetAiSkills({
    allVersions: false,
    skip: 0,
    take: 1000
  })

  const visibleSkills = useMemo(() => {
    if (!skillsData?.skills) return []

    const searchLower = searchQuery.toLowerCase().trim()
    return skillsData.skills
      .filter(skill => {
        const content = skill.skillContent || {}
        return content.enabled !== false
      })
      .filter(skill => {
        if (!searchLower) return true
        const nameMatch = skill.skillName?.toLowerCase().includes(searchLower)
        const descMatch = skill.skillContent?.description?.toLowerCase().includes(searchLower)
        return nameMatch || descMatch
      })
  }, [skillsData, searchQuery])

  const handleSearchChange = useCallback((debouncedValue) => {
    setSearchQuery(debouncedValue?.value ?? debouncedValue ?? '')
  }, [])

  if (isLoading) {
    return (
      <PageLayout variant='constrained'>
        <Loading />
      </PageLayout>
    )
  }

  return (
    <PageLayout variant='constrained'>
      <PageHeading title='Skills'>
        <DebouncedInput
          placeholder='Search skills...'
          defaultValue={searchQuery}
          onChange={handleSearchChange}
          delay={300}
          style={{ minWidth: 'unset' }}
        />
      </PageHeading>
      <Divider />
      {visibleSkills.length === 0 ? (
        <NoResults message='No skills available' />
      ) : (
        <FadeIn>
          <FlexColumn className='gap-sm'>
            {visibleSkills.map((skill) => (
              <SkillCard skill={skill} key={`${skill.skillId}-${skill.version}`} />
            ))}
          </FlexColumn>
        </FadeIn>
      )}
    </PageLayout>
  )
}

export default SkillsHome
